<template>
  <WorkBasicIconDialog
    ref="dialog"
    v-bind="$props"
    iconCode="$wWarning"
    color="warning"
  >
    <template #header>
      <slot name="header">
        {{ $t('Dialogs.WarningDialog.title') }}
      </slot>
    </template>

    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <slot
        name="dialog-actions"
        :trigger-resolve="triggerResolve"
        :trigger-reject="triggerReject"
        :close="close"
      >
        <template #abort-action>
          <slot
            name="abort-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
          >
            <template #abort-action-text>
              <slot name="abort-action-text" />
            </template>
          </slot>
        </template>

        <template #accept-action>
          <slot
            name="accept-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
            :accept-action-text="acceptActionText"
          >
            <template #accept-action-text>
              <slot name="accept-action-text" />
            </template>
          </slot>
        </template>
      </slot>
    </template>
  </WorkBasicIconDialog>
</template>

<script>
// components
import WorkBasicIconDialog from "./WorkBasicIconDialog";
// services & helpers
import i18n from "@/language/i18n";
import WORK_DIALOG_SIZES from '@/components/base_components/dialog/components/enums/WORK_DIALOG_SIZES';
import { ref } from 'vue';


export default {
  name: "WorkWarningDialog",
  components: { 
    WorkBasicIconDialog
  },
  props: {
    iconLabel: { type: String, default: i18n.t('Dialogs.WarningDialog.title') },
    message: { type: String, default: i18n.t('Dialogs.WarningDialog.message') },
    acceptActionText: { type: String, default: i18n.t('Dialogs.BasicDialog.accept') },
    width: { type: String, default: WORK_DIALOG_SIZES.SMALL },
    noSimpleClose: { type: Boolean, default: true },
    description: { type: String },
    hasHtml: { type: Boolean, default: false }
  },
  setup() {
    const dialog = ref(null);

    function open() {
      return dialog.value.open();
    }
    return { open, dialog }
  }
}
</script>
